document.addEventListener('DOMContentLoaded', function () {
  const testimonialSections = document.querySelectorAll(
    '[data-section-type="home-testimonials"]',
  );

  testimonialSections.forEach((section) => {
    const sectionId = section.dataset.sectionId;

    if (!sectionId) {
      console.warn('Home Testimonials: Section ID not found');
      return;
    }

    const swiperContainer = document.querySelector(
      `[data-section-id="${sectionId}"] .home-testimonials__swiper`,
    );
    const paginationContainer = document.querySelector(
      `[data-section-id="${sectionId}"] .home-testimonials__pagination`,
    );

    if (!swiperContainer || !paginationContainer) {
      console.warn(
        `Home Testimonials: Swiper or pagination container not found in section ${sectionId}`,
      );
      return;
    }

    // Initialize Swiper for this specific section using section ID
    new Swiper(swiperContainer, {
      slidesPerView: 1,
      effect: 'fade',
      fadeEffect: {
        crossFade: true,
      },
      autoplay: {
        delay: 5000,
      },
      pagination: {
        el: paginationContainer,
        clickable: true,
        renderBullet: function (index, className) {
          return (
            '<span class="' +
            className +
            ' swiper-pagination-bullet-custom">' +
            '0' +
            (index + 1) +
            '</span>'
          );
        },
        bulletClass: 'home-testimonials__bullet',
        bulletActiveClass: 'home-testimonials__bullet--active',
      },
    });
  });
});
